import { combineReducers } from 'redux'
import records from './records'
import stagedRecord from './stagedRecord'
import uiFlags from './uiFlags'
import position from './position'

export default combineReducers({
  records,
  stagedRecord,
  uiFlags,
  position,
})
